import { Components, Theme } from '@mui/material';
import { common } from '@mui/material/colors';

export const getMuiIconButton = (
  theme: Theme,
): Components['MuiIconButton'] => ({
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'camera' },
          style: {
            backgroundColor: common.black,
            borderRadius: theme.shape.borderRadius * 2,
            height: 42,
            width: 42,
            '&:hover': {
              backgroundColor: common.black,
            },
            '& .MuiSvgIcon-root': {
              width: 24,
              height: 24,
              color: theme.palette.primary.main,
            },
          },
        },
      ],
    },
  },
});
